// extracted by mini-css-extract-plugin
export var poster = "poster-module--poster--srYO8";
export var details = "poster-module--details--QhUQY";
export var hand = "poster-module--hand--830RN";
export var buttons = "poster-module--buttons--KXl2v";
export var features = "poster-module--features--NJ3yn";